export default __webpack_public_path__ + "static/media/segre25.79ffd5a6.jpg";